/**
 * Types of integration applications
 */
export enum IntegrationType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

/**
 * Tab type for the main panel
 */
export enum TabType {
  CONFIGURATION = 'configuration',
  ACCESS_PERMISSIONS = 'access_permissions',
  BASIC_INFO = 'basic_info',
}
